/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Applications {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description Retrieve all custom application workflows for the current organization.
   *
   * @tags Applications
   * @name ListWorkflows
   * @summary List Workflows
   * @request GET:/api/applications/workflows
   * @secure
   */
  listWorkflows = (params = {}) =>
    this.http.request({
      path: `/api/applications/workflows`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new application workflow with custom stages and required metadata fields.
   *
   * @tags Applications
   * @name CreateWorkflow
   * @summary Create Workflow
   * @request POST:/api/applications/workflows
   * @secure
   */
  createWorkflow = (data, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve the catalog of pre-configured default workflow templates.
   *
   * @tags Applications
   * @name ListWorkflowTemplates
   * @summary List Workflow Templates
   * @request GET:/api/applications/workflows/templates
   * @secure
   */
  listWorkflowTemplates = (query, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows/templates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve the full visual canvas graph and transition rules for a specific template.
   *
   * @tags Applications
   * @name GetWorkflowTemplate
   * @summary Get Workflow Template
   * @request GET:/api/applications/workflows/templates/{template_id}
   * @secure
   */
  getWorkflowTemplate = (templateId, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows/templates/${templateId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Instantiate a new workflow cloned from a market template preset.
   *
   * @tags Applications
   * @name CreateWorkflowFromTemplate
   * @summary Create Workflow from Template
   * @request POST:/api/applications/workflows/from-template
   * @secure
   */
  createWorkflowFromTemplate = (data, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows/from-template`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve visual canvas graph (nodes, edges, viewport, attached database summaries).
   *
   * @tags Applications
   * @name GetWorkflowCanvas
   * @summary Get Workflow Canvas
   * @request GET:/api/applications/workflows/{workflow_id}/canvas
   * @secure
   */
  getWorkflowCanvas = (workflowId, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows/${workflowId}/canvas`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Persist visual canvas graph and dual-sync stages and transitions.
   *
   * @tags Applications
   * @name SaveWorkflowCanvas
   * @summary Save Workflow Canvas
   * @request PUT:/api/applications/workflows/{workflow_id}/canvas
   * @secure
   */
  saveWorkflowCanvas = (workflowId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows/${workflowId}/canvas`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get details of a specific application workflow.
   *
   * @tags Applications
   * @name GetWorkflow
   * @summary Get Workflow
   * @request GET:/api/applications/workflows/{workflow_id}
   * @secure
   */
  getWorkflow = (workflowId, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows/${workflowId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing application workflow (stages, required fields, default status).
   *
   * @tags Applications
   * @name UpdateWorkflow
   * @summary Update Workflow
   * @request PUT:/api/applications/workflows/{workflow_id}
   * @secure
   */
  updateWorkflow = (workflowId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows/${workflowId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a workflow if no active applications are assigned to it.
   *
   * @tags Applications
   * @name DeleteWorkflow
   * @summary Delete Workflow
   * @request DELETE:/api/applications/workflows/{workflow_id}
   * @secure
   */
  deleteWorkflow = (workflowId, params = {}) =>
    this.http.request({
      path: `/api/applications/workflows/${workflowId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Retrieve all rental applications for the organization.
   *
   * @tags Applications
   * @name GetAllApplications
   * @summary List Applications
   * @request GET:/api/applications
   * @secure
   */
  getAllApplications = (query, params = {}) =>
    this.http.request({
      path: `/api/applications`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve a paginated list of rental applications.
   *
   * @tags Applications
   * @name GetAllApplicationsPaged
   * @summary List Applications (Paged)
   * @request GET:/api/applications/paged
   * @secure
   */
  getAllApplicationsPaged = (query, params = {}) =>
    this.http.request({
      path: `/api/applications/paged`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve a specific rental application by its ID.
   *
   * @tags Applications
   * @name GetApplication
   * @summary Get Application
   * @request GET:/api/applications/{application_id}
   * @secure
   */
  getApplication = (applicationId, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Permanently delete a rental application.
   *
   * @tags Applications
   * @name DeleteApplication
   * @summary Delete Application
   * @request DELETE:/api/applications/{application_id}
   * @secure
   */
  deleteApplication = (applicationId, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Retrieve all applications associated with a specific property.
   *
   * @tags Applications
   * @name GetByProperty
   * @summary List Applications by Property
   * @request GET:/api/applications/property/{property_id}
   * @secure
   */
  getByProperty = (propertyId, params = {}) =>
    this.http.request({
      path: `/api/applications/property/${propertyId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve all applications with a specific status.
   *
   * @tags Applications
   * @name GetByStatus
   * @summary List Applications by Status
   * @request GET:/api/applications/status/{status}
   * @secure
   */
  getByStatus = (status, params = {}) =>
    this.http.request({
      path: `/api/applications/status/${status}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Accept or reject a rental application.
   *
   * @tags Applications
   * @name Decide
   * @summary Make Decision
   * @request PUT:/api/applications/{application_id}/decide
   * @secure
   */
  decide = (applicationId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/decide`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Manually update the status of a rental application.
   *
   * @tags Applications
   * @name UpdateStatus
   * @summary Update Status
   * @request PATCH:/api/applications/{application_id}/status
   * @secure
   */
  updateStatus = (applicationId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/status`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Transition an approved application to CONTRACT_PROPOSED and generate a HomySign contract from the specified template (or a blank document if no template_id is provided).
   *
   * @tags Applications
   * @name CreateContract
   * @summary Create Contract
   * @request POST:/api/applications/{application_id}/create-contract
   * @secure
   */
  createContract = (applicationId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/create-contract`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Invite a co‑signer (aval / fiador / garante) for an existing application. The co‑signer will receive an invitation link.
   *
   * @tags Applications
   * @name InviteCoSigner
   * @summary Invite Co‑Signer
   * @request POST:/api/applications/{application_id}/co-signers/invite
   * @secure
   */
  inviteCoSigner = (applicationId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/co-signers/invite`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Review, verify or reject a guarantor/co-signer, recording credit score (DICOM/Equifax) and partner guarantee details.
   *
   * @tags Applications
   * @name ScreenGuarantor
   * @summary Screen Guarantor / Co-Signer
   * @request POST:/api/applications/{application_id}/guarantors/{guarantor_id}/screening
   * @secure
   */
  screenGuarantor = (applicationId, guarantorId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/guarantors/${guarantorId}/screening`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Transition an application to a custom pipeline stage, dynamically enforcing required metadata fields.
   *
   * @tags Applications
   * @name TransitionStage
   * @summary Transition Application Stage
   * @request POST:/api/applications/{application_id}/transition-stage
   * @secure
   */
  transitionStage = (applicationId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/transition-stage`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Assign a custom workflow to an application.
   *
   * @tags Applications
   * @name AssignWorkflow
   * @summary Assign Workflow to Application
   * @request POST:/api/applications/{application_id}/assign-workflow/{workflow_id}
   * @secure
   */
  assignWorkflow = (applicationId, workflowId, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/assign-workflow/${workflowId}`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get the workflow details, current stage, and metadata for an application.
   *
   * @tags Applications
   * @name GetApplicationWorkflowStatus
   * @summary Get Application Workflow Status
   * @request GET:/api/applications/{application_id}/workflow-status
   * @secure
   */
  getApplicationWorkflowStatus = (applicationId, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/workflow-status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add a reference to an application.
   *
   * @tags Applications
   * @name AddReference
   * @summary Add Reference
   * @request POST:/api/applications/{application_id}/references
   * @secure
   */
  addReference = (applicationId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/references`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List references for an application.
   *
   * @tags Applications
   * @name ListReferences
   * @summary List References
   * @request GET:/api/applications/{application_id}/references
   * @secure
   */
  listReferences = (applicationId, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/references`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Trigger an automated telephony / AI voice verification call for a tenant reference.
   *
   * @tags Applications
   * @name TriggerPhoneCheck
   * @summary Trigger Automated Telephony Reference Check
   * @request POST:/api/applications/{application_id}/references/{reference_id}/trigger-phone-check
   * @secure
   */
  triggerPhoneCheck = (applicationId, referenceId, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/references/${referenceId}/trigger-phone-check`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Initiate a screening for an application.
   *
   * @tags Applications
   * @name RequestScreening
   * @summary Request Screening
   * @request POST:/api/applications/{application_id}/screenings
   * @secure
   */
  requestScreening = (applicationId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/screenings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List screenings for an application.
   *
   * @tags Applications
   * @name ListScreenings
   * @summary List Screenings
   * @request GET:/api/applications/{application_id}/screenings
   * @secure
   */
  listScreenings = (applicationId, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/screenings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Initiate a credit check for the application using Equifax/DICOM. Requires explicit MANAGER role.
   *
   * @tags Applications
   * @name InitiateCreditCheck
   * @summary Initiate Credit Check
   * @request POST:/api/applications/{application_id}/credit-check
   * @secure
   */
  initiateCreditCheck = (applicationId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/credit-check`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List status history for an application.
   *
   * @tags Applications
   * @name ListStatusHistory
   * @summary List Status History
   * @request GET:/api/applications/{application_id}/history
   * @secure
   */
  listStatusHistory = (applicationId, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/history`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve real-time digital guarantee quotes and partner credit scoring for an application.
   *
   * @tags Applications
   * @name GetGuaranteeQuotes
   * @summary Get Digital Guarantee Quotes
   * @request POST:/api/applications/{application_id}/guarantees/quote
   * @secure
   */
  getGuaranteeQuotes = (applicationId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/guarantees/quote`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Submit application to digital guarantee provider for underwriting.
   *
   * @tags Applications
   * @name ApplyForGuarantee
   * @summary Apply for Digital Guarantee
   * @request POST:/api/applications/{application_id}/guarantees/apply
   * @secure
   */
  applyForGuarantee = (applicationId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/guarantees/apply`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Issue official policy number and bind surety bond to application and rental lease.
   *
   * @tags Applications
   * @name BindGuaranteePolicy
   * @summary Bind Digital Guarantee Policy
   * @request POST:/api/applications/{application_id}/guarantees/{guarantee_id}/bind
   * @secure
   */
  bindGuaranteePolicy = (applicationId, guaranteeId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/guarantees/${guaranteeId}/bind`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve all quoted, approved, and active digital guarantee policies for an application.
   *
   * @tags Applications
   * @name ListApplicationGuarantees
   * @summary List Guarantees for Application
   * @request GET:/api/applications/{application_id}/guarantees
   * @secure
   */
  listApplicationGuarantees = (applicationId, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/guarantees`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  applyGuarantee = (applicationId, data, params = {}) =>
    this.applyForGuarantee(applicationId, data, params);
  bindGuarantee = (applicationId, guaranteeId, data = {}, params = {}) =>
    this.bindGuaranteePolicy(applicationId, guaranteeId, data, params);
  listGuarantees = (applicationId, params = {}) =>
    this.listApplicationGuarantees(applicationId, params);
  /**
   * @description Transition an application to a custom pipeline stage.
   * @request POST:/api/applications/{application_id}/transition-stage
   */
  transitionStage = (applicationId, data, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/transition-stage`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Assign a custom workflow to an application.
   * @request POST:/api/applications/{application_id}/assign-workflow/{workflow_id}
   */
  assignWorkflow = (applicationId, workflowId, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/assign-workflow/${workflowId}`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get the workflow details, current stage, and metadata for an application.
   * @request GET:/api/applications/{application_id}/workflow-status
   */
  getWorkflowStatus = (applicationId, params = {}) =>
    this.http.request({
      path: `/api/applications/${applicationId}/workflow-status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
